import { render } from "./BarChart.vue?vue&type=template&id=083c6d06&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import "./BarChart.vue?vue&type=style&index=0&id=083c6d06&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083c6d06"]])

export default __exports__